import {
  FaHome,
  FaBullhorn,
  FaMoneyCheckAlt,
  FaExchangeAlt,
  FaCreditCard,
  FaWallet,
} from "react-icons/fa";

const Sidebar = () => {
  return (
    <aside className="w-64 bg-[#0B0F1F] text-white min-h-screen">
      <nav className="space-y-1 text-sm">
        <a href="#" className="flex items-center px-6 text-white py-3 hover:bg-[#11182f]">
          <FaHome className="mr-3 text-white" /> Dashboard
        </a>
        <a href="#" className="flex items-center text-white px-6 py-3 hover:bg-[#11182f]">
          <FaBullhorn className="mr-3 text-white" /> Campaigns
        </a>
        <a href="#" className="flex items-center text-white px-6 py-3 hover:bg-[#11182f]">
          <FaMoneyCheckAlt className="mr-3 text-white" /> Roles
        </a>
        <a
          href="#"
          className="flex items-center px-6 py-3 text-white bg-[#11182f] border-l-4 border-[#00AEEF] font-semibold"
        >
          <FaExchangeAlt className="mr-3 text-white" /> Wallet & Payout
        </a>
        <a href="#" className="flex items-center px-6 py-3 text-white hover:bg-[#11182f]">
          <FaCreditCard className="mr-3 text-white" /> Refunds
        </a>
        <a href="#" className="flex items-center px-6 py-3 hover:bg-[#11182f] text-white">
          <FaWallet className="mr-3 text-white" /> Payout Methods
        </a>
      </nav>
    </aside>
  );
};

export default Sidebar;
